module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ffca1ed0934b9b2ece7dd36f3a0f4fb0.png";